export default __webpack_public_path__ + "e542c88c3d6974c45780c290ac558bbb.png";